import { render } from "./TenantApplications.vue?vue&type=template&id=365ad2c0&ts=true"
import script from "./TenantApplications.vue?vue&type=script&lang=ts"
export * from "./TenantApplications.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__